import type { EmblaPluginType, EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect } from 'react';

export type UseCarouselProps = EmblaOptionsType & {
  displayIndex?: number;
  onSelect?: (index: number) => void;
};

export function useCarousel(
  props: UseCarouselProps = {},
  plugins?: EmblaPluginType[]
) {
  const { displayIndex = 0, onSelect, ...emblaProps } = props;
  const emblaCarousel = useEmblaCarousel(emblaProps, plugins);
  const [_, emblaApi] = emblaCarousel;

  const handleSelect = useCallback(() => {
    if (!emblaApi || !onSelect) return;
    const value = emblaApi.selectedScrollSnap();

    if (value !== displayIndex) {
      onSelect(value);
    }
  }, [emblaApi, onSelect, displayIndex]);

  useEffect(() => {
    if (!emblaApi) return;

    if (emblaApi.selectedScrollSnap() !== displayIndex) {
      emblaApi.scrollTo(displayIndex);
    }
  }, [displayIndex, emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.on('select', handleSelect).on('reInit', handleSelect);
  }, [emblaApi, handleSelect]);

  return emblaCarousel;
}
